"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.replace");require("core-js/modules/es6.function.name");require("core-js/modules/web.dom.iterable");require("core-js/modules/es6.number.constructor");

























































var _user = require("@/utils/user"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { name: 'TaskSkillMap', props: { mapId: { type: String }, taskId: { type: Number } }, data: function data() {return { mapPosData: [], // 列表数据
      nextPosData: [], hasPosData: [], pointList: [], nextPos: '', addPos: false, nextPostShow: false, title: '', delIndex: '', mapSrc: '', searchData: { page: 1, // 页码条数
        rows: 10 }, addData: { posId: '', mapId: '', taskId: '' }, rules: { posId: [{ required: true, message: '请选择下个巡点', trigger: 'blur' }] } };}, mounted: function mounted() {console.log('map->mapId:' + this.mapId);this.getMapPosList(this.mapId);this.handleGetMapInfo(this.mapId);}, methods: { handleGetMapInfo: function handleGetMapInfo(mapId, taskId) {var self = this;self.addData.taskId = taskId;self.getData('/api/temi/robot/map?id=' + mapId, {}, function (res) {if (res) {self.mapSrc = res[0].image;}});}, getMapPosList: function getMapPosList(mapId) {mapId = Number(mapId);var self = this;
      self.mapPosData = [];
      self.hasPosData = [];
      self.addData.mapId = mapId;
      // 获取map详情
      self.handleGetMapInfo(mapId);
      var path = '/api/temi/robot/map/' + mapId + '/pos';
      self.getData(path, {}, function (res) {
        console.log('delIndex:' + self.delIndex);
        console.log(res);
        console.log(res[0].x);
        // 偏移减少了
        if (self.delIndex !== '') {
          for (var i in res) {
            console.log('i->' + i + ',index:' + self.delIndex);
            if (i >= self.delIndex) {
              console.log('修改x');
              // res[i].x = res[i].x
              console.log(res[i].x);
              self.modMapPos(res[i]);
            }
          }
          self.delIndex = '';
        }
        self.mapPosData = res;
        self.hasPosData = [];
        for (var index in self.mapPosData) {
          self.hasPosData.push(index);
        }
      });
    },
    handleSetNextShow: function handleSetNextShow(pos) {
      this.nextPos = pos;
      this.nextPostShow = true;
    },
    handleSetPosOrder: function handleSetPosOrder() {
      var self = this;
      self.nextPosData[self.addData.posId] = self.nextPos;
      self.hasPosData.forEach(function (pos, index) {
        if (pos === self.addData.posId) {
          self.hasPosData.splice(index, 1);
        }
      });
      console.log(this.nextPosData);
      this.closeNextPosShow();
      console.log(self.hasPosData.length);
      if (self.hasPosData.length === 0) {
        self.handleOnSubmit();
      }
    },
    handleGetPointList: function handleGetPointList(pointList) {
      var self = this;
      self.pointList = pointList;
    },
    handleSetPoint: function handleSetPoint(pos) {var _this = this; // 设置为巡点
      var self = this;
      self.$confirm('确定需要将该点设为巡点吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        console.log('设置');
        // 排序
        var self = _this;
        var posDataArr = [];
        var order = Number(0);
        console.log(self.pointList);
        if (self.pointList.length > 0) {
          order = Number(self.pointList[self.pointList.length - 1].orderNum);
          if (self.pointList[self.pointList.length - 1].endPositionName !== pos.name) {
            order = order + 1;
            var postData = {
              positionId: self.pointList[self.pointList.length - 1].endPositionId,
              positionName: self.pointList[self.pointList.length - 1].endPositionName,
              orderNum: order,
              endPositionId: pos.id,
              endPositionName: pos.name,
              flowType: 1,
              taskId: Number(self.addData.taskId) };

            posDataArr.push(postData);
          } else {
            if (self.pointList[self.pointList.length - 1].flowType === 0) {
              return true;
            }
          }
        }

        order = order === 0 ? 0 : order + 1;
        var lastPosData = {
          positionId: pos.id,
          positionName: pos.name,
          orderNum: order,
          endPositionId: pos.id,
          endPositionName: pos.name,
          flowType: 0,
          taskId: Number(self.addData.taskId) };

        posDataArr.push(lastPosData);

        console.log(posDataArr);
        var path = '/api/temi/robot/task/' + self.taskId + '/flow';
        self.postData(path, posDataArr, function (res) {
          self.$message({
            message: '添加成功!',
            type: 'success' });

          self.onCencal();
          self.$emit('handleGetPointList', self.mapId);
        });
      }).catch(function () {});
    },
    handleOnSubmit: function handleOnSubmit() {
      // 排序
      var self = this;
      var posDataArr = [];
      var order = Number(0);
      for (var index in self.nextPosData) {
        var postData = {
          positionId: self.nextPosData[index].positionId,
          positionName: self.nextPosData[index].name,
          orderNum: order,
          endPositionId: self.nextPosData[index].id,
          endPositionName: self.nextPosData[index].name,
          flowType: 0,
          taskId: Number(self.addData.taskId) };

        if (index > 0) {
          var last = Number(index) - 1;
          var lastPosData = {
            positionId: self.nextPosData[last].id,
            positionName: self.nextPosData[last].name,
            orderNum: order,
            endPositionId: self.nextPosData[index].id,
            endPositionName: self.nextPosData[index].name,
            flowType: 1,
            taskId: Number(self.addData.taskId) };

          posDataArr.push(lastPosData);
          order = order + 1;
          postData.orderNum = order;
        }
        order = order + 1;
        posDataArr.push(postData);
      }

      console.log(posDataArr);
      var path = '/api/temi/robot/task/' + self.taskId + '/flow';
      self.postData(path, posDataArr, function (res) {
        self.$message({
          message: '添加成功!',
          type: 'success' });

        self.onCencal();
        self.$emit('handleGetPointList', self.mapId);
      });
    },
    checkPermission: _user.checkPermission,
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addPos = true;
    },
    closeNextPosShow: function closeNextPosShow() {
      var self = this;
      self.$refs['setPosOrder'].resetFields();
      self.addData.posId = '';
      self.nextPostShow = false;
    },
    closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addPos'].resetFields();
      this.cleanData();
      this.addPos = false;
    },
    updateMenu: function updateMenu(pos) {// 修改操作
      this.title = '修改';
      var self = this;
      self.addPos = true;
      self.addData = {
        id: pos.id,
        name: pos.name,
        mapId: pos.mapId };

    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addPos.validate(function (valid) {
        if (valid) {
          var mapId = self.addData.mapId;
          var path = '/api/temi/robot/map/' + mapId + '/pos';
          self.postData(path, self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.getMapPosList(mapId);
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(pos, index) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        var path = '/api/temi/robot/map/' + pos.mapId + '/pos?id=' + pos.id;
        self.delData(path, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.onCencal();
          self.delIndex = index;
          self.getMapPosList(pos.mapId);
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.cleanData();
      this.addPos = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData.name = '';
    },
    move: function move(e, pos) {var _this2 = this;
      var odiv = e.target.parentNode; // 获取目标元素
      // 阻止默认事件的方法,如果不阻止默认事件onmouseup会无法触发
      e.preventDefault();
      // 算出鼠标相对元素的位置
      var starX = odiv.style.left.replace('px', '');
      var starY = odiv.style.top.replace('px', '');
      var disX = e.clientX;
      var disY = e.clientY;
      document.onmousemove = function (e) {
        console.log('移动');
        // 鼠标按下并移动的事件
        // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        // 因为img居中对齐，所以还要减去目标元素距离body的偏移量
        var left = e.clientX - disX + Number(starX);
        var top = e.clientY - disY + Number(starY);
        // 移动当前元素
        odiv.style.left = left + 'px';
        odiv.style.top = top + 'px';
      };
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
        var starX = odiv.style.left.replace('px', '');
        var starY = odiv.style.top.replace('px', '');
        var posData = {
          id: pos.id,
          mapId: pos.mapId,
          x: starX,
          y: starY };

        _this2.modMapPos(posData);
      };
    },
    modMapPos: function modMapPos(posData) {
      var path = '/api/temi/robot/map/' + posData.mapId + '/pos';
      this.postData(path, posData, function (res) {});
    },
    imageLoad: function imageLoad(e, pos, index) {
      console.log('加载：' + pos.name, index);
      var odiv = e.target.parentNode; // 获取目标元素
      var x = pos.x === null ? 0 : pos.x;
      var y = pos.y === null ? 0 : pos.y;
      console.log('原先X：', x);
      // 偏移
      var xIndex = parseInt(index % 4);
      console.log('lmode:', xIndex);
      x = parseInt(x / 2);
      console.log('之后X：', x);
      var xOrigin = 0 - xIndex * 150;
      xOrigin = xOrigin + x;
      var yIndex = parseInt(index / 4);
      var yOrigin = yIndex * 15;
      if (y) {
        y = y / 2;
        y = y - yOrigin;
      }
      odiv.style.left = xOrigin + 'px';
      odiv.style.top = y + 'px';
      console.log('x->' + xOrigin);
      console.log('y->' + y);
    } } };exports.default = _default;